/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProcessDepositPaymentResponse { 
    /**
     * Transaction ID
     */
    transactionId: string;
    /**
     * Stripe Payment Intent client secret for confirming payment
     */
    paymentIntentClientSecret: string;
    /**
     * Transaction status
     */
    status: ProcessDepositPaymentResponse.StatusEnum;
    /**
     * Stripe Customer ID (only present when using new card, enables \"Save Card\" checkbox)
     */
    customerId?: string;
    /**
     * Stripe ephemeral key secret (only present when using new card, required for \"Save Card\" checkbox)
     */
    ephemeralKeySecret?: string;
}
export namespace ProcessDepositPaymentResponse {
    export type StatusEnum = 'pending' | 'succeeded' | 'requires_action';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Succeeded: 'succeeded' as StatusEnum,
        RequiresAction: 'requires_action' as StatusEnum
    };
}


